
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Investissez intelligemment pour réussir",
    description:
      "Découvrez comment définir un budget efficace pour vos campagnes Instagram Ads et maximiser vos résultats. ALEO vous guide pour optimiser vos investissements.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
